/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
export const AppConfigGen = {
  "ADMIN_DRAWER_MENU_ENABLED": true,
  "APPAK": "web-496f6acc-bba2-11ec-8422-0242ac120002",
  "CLOUD_REGION": "us-east-1",
  "COGNITO_USER_POOL": "us-east-1_BS67JdKz0",
  "COGNITO_USER_POOL_CLIENT_ID": "4hcb54cpfohqn7s7ivtbtaq6hj",
  "COMPANY_NAME": "Dolphin Digital",
  "DEFAULT_COUNTRY": "US",
  "DEFAULT_CURRENCY": "USD",
  "DEFAULT_LANG": "en",
  "DEFAULT_ZONEINFO": "America/Chicago",
  "DESCR": "Dolphin",
  "ENDPOINT": "https://tvaqma11rf.execute-api.us-east-1.amazonaws.com/Prod",
  "NAME": "Dolphin",
  "ORGSU_ACCESS_ALLOWED": true,
  "PASSWORD_POLICY": "Password should be minumum 6 characters with numbers and letters.",
  "SUPPORT_EMAIL": "support@dolphin-digital.com",
  "TINT_COLOUR": "#2029F1",
  "TITLE": "Dolphin",
  "USER_PRIMARY": "email",
  "WEBAPP_LINK": "https://d3mpmgymth5glj.cloudfront.net"
}


// WEBPACK FOOTER //
// ./src/AppConfigGen.js